export const userPermissions = {
  display: {
    displayProjectMetricsResult: 'displayProjectMetricsResult',
    displayExternalASRModels: 'displayExternalASRModels',
    displayMetricTemplates: 'displayMetricTemplates',
    displayRecognizeRules: 'displayRecognizeRules',
    displayAPModel: 'displayAPModel',
    displayAuditLogs: 'displayAuditLogs',
    displayDashboards: 'displayDashboards',
    displayLiveReports: 'displayLiveReports',
    displayProjectMetrics: 'displayProjectMetrics',
    displayProjectPreset: 'displayProjectPreset',
    displayProjects: 'displayProjects',
    displayDictionaries: 'displayDictionaries',
    displayPresets: 'displayPresets',
    displayRecords: 'displayRecords',
    displayChannels: 'displayChannels',
    displayAliases: 'displayAliases',
    displaySettings: 'displaySettings',
    displayRepStatusCol: 'displayRepStatusCol',
    displayUsers: 'displayUsers',
    dis: 'dis',
    displayChatsProjects: 'displayChatsProjects',
    displayChatProjectMetrics: 'displayChatProjectMetrics',
    displayChats: 'displayChats',
    displayDashboardsShare: 'displayDashboardsShare',
    displayLiveReportsTasks: 'displayLiveReportsTasks',
    displaySender: 'displaySender',
    displayIntegrationAuth: 'displayIntegrationAuth',
    displayChatRoles: 'displayChatRoles',
    displayQMStats: 'displayQMStats',
    displayMFTasks: 'displayMFTasks',
    displayQMAppellation: 'displayQMAppellation',
    displayQMMforms: 'displayQMMforms',
    displayQMTeams: 'displayQMTeams',
    displayRSTemplates: 'displayRSTemplates',
  },
  action: {
    actionDeleteRecords: 'actionDeleteRecords',
    actionGetDefaultASRModel: 'actionGetDefaultASRModel',
    actionPostDefaultASRModel: 'actionPostDefaultASRModel',
    actionDeleteRecord: 'actionDeleteRecord',
    actionTakeDashboard: 'actionTakeDashboard',
    actionUploadRecord: 'actionUploadRecord',
    actionCloneLiveReport: 'actionCloneLiveReport',
    actionCloneChatLiveReport: 'actionCloneChatLiveReport',
    actionEditLiveReport: 'actionEditLiveReport',
    actionEditChatLiveReport: 'actionEditChatLiveReport',
    actionEditLiveReportGraph: 'actionEditLiveReportGraph',
    actionEditChatLiveReportGraph: 'actionEditChatLiveReportGraph',
    actionPutLiveReportGraphsLayout: 'actionPutLiveReportGraphsLayout',
    actionPutChatLiveReportGraphsLayout: 'actionPutChatLiveReportGraphsLayout',
    actionGetBilling: 'actionGetBilling',
    actionDeleteChat: 'actionDeleteChat',
    actionGetAllGPTIntegrations: 'actionGetAllGPTIntegrations',
    actionGetGPTGroup: 'actionGetGPTGroup',
    actionGetGPTGroupMetrics: 'actionGetGPTGroupMetrics',
    actionGetGPTGroups: 'actionGetGPTGroups',
  },
};
